module.exports = __webpack_public_path__ + "static/media/info-feedback.568f0f55.svg";